import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Divider from '@material-ui/core/Divider'

import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'

import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'
import SaveIcon from '@material-ui/icons/Save'

import { handleSaveUser, handleUpdatePassword } from '../../actions/users'
import t from '../../utils/lang/user'

const TabContainer = (props) => (
  <Typography component="div">
    {props.children}
  </Typography>
)

const styles = theme => ({
  cardHeader: {
    fontWeight: '500'
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  cardActions: {
    justifyContent: 'flex-end'
  },
  saveButton: {
    position: 'fixed',
    bottom: '15px',
    right: '15px'
  },
});

class UserDetailsCard extends Component {
  state = {
    tab: 0,
    firstName: '',
    lastName: '',
    jobTitle: '',
    email: '',
    phone: '',
    newPassword: '',
    repeatPassword: '',
    snackbarOpen: false,
    snackMessage: ''
  }

  componentDidMount () {
    const { userId, users } = this.props
    const user = users[userId]

    this.setState(() => ({
      firstName: user.firstName ? user.firstName : '',
      lastName: user.lastName ? user.lastName : '',
      jobTitle: user.jobTitle ? user.jobTitle : '',
      email: user.email,
      phone: user.phone ? user.phone : ''
    }))
  }

  handleTabToggle = (event, tab) => {
    this.setState({ tab })
  }

  handleChangeFirstName = e => {
    const firstName = e.target.value

    this.setState(() => ({
      firstName
    }))
  }

  handleChangeLastName = e => {
    const lastName = e.target.value

    this.setState(() => ({
      lastName
    }))
  }

  handleChangeJobTitle = e => {
    const jobTitle = e.target.value

    this.setState(() => ({
      jobTitle
    }))
  }

  handleChangeEmail = e => {
    const email = e.target.value

    this.setState(() => ({
      email
    }))
  }

  handleChangePhone = e => {
    const phone = e.target.value

    this.setState(() => ({
      phone
    }))
  }

  handleChangeNewPassword = e => {
    const newPassword = e.target.value

    this.setState(() => ({
      newPassword
    }))
  }

  handleChangeRepeatPassword = e => {
    const repeatPassword = e.target.value

    this.setState(() => ({
      repeatPassword
    }))
  }

  handleSaveData = e => {
    const { dispatch, userId } = this.props
    const { firstName, lastName, jobTitle, email, phone } = this.state

    const data = {
      firstName,
      lastName,
      jobTitle,
      email,
      phone
    }

    dispatch(handleSaveUser(userId, data))

    this.setState({ snackMessage: 'Profile details have been saved.', newPassword: '', repeatPassword: '' })
    this.handleOpenSnackbar()
  }

  handleSavePassword = e => {
    const { dispatch, userId } = this.props
    const { newPassword, repeatPassword } = this.state

    if (newPassword === '' || repeatPassword === '') {
      this.setState({ snackMessage: 'Password can\'t be empty.' })

    } else if (newPassword !== repeatPassword) {
      this.setState({ snackMessage: 'Passwords do not match.' })

    } else {
      dispatch(handleUpdatePassword(userId, newPassword))
      this.setState({ snackMessage: 'Password has been changed.', newPassword: '', repeatPassword: '' })
    }

    this.handleOpenSnackbar()
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  render() {
    const { tab, firstName, lastName, jobTitle, email, phone, newPassword, repeatPassword, snackMessage } = this.state
    const { classes } = this.props

    const lang = 'en'

    return (
      <Fragment>
        <Card>
          <Tabs value={tab} onChange={this.handleTabToggle}>
            <Tab label={t[lang].contactInformation} classes={{ root: classes.tabRoot }} />
            <Tab label={t[lang].password} classes={{ root: classes.tabRoot }} />
          </Tabs>
          <Divider />

          {tab === 0 &&
            <TabContainer>
              <CardContent>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="firstName"
                    label={t[lang].firstName}
                    value={firstName}
                    onChange={this.handleChangeFirstName}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="lastName"
                    label={t[lang].lastName}
                    value={lastName}
                    onChange={this.handleChangeLastName}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="jobTitle"
                    label={t[lang].jobTitle}
                    value={jobTitle}
                    onChange={this.handleChangeJobTitle}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="email"
                    label={t[lang].email}
                    value={email}
                    type="email"
                    onChange={this.handleChangeEmail}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="phone"
                    label={t[lang].phone}
                    value={phone}
                    type="phone"
                    onChange={this.handleChangePhone}
                  />
                </FormControl>
              </CardContent>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button color="primary" onClick={this.handleSaveData}>
                  {t[lang].save}
                </Button>
              </CardActions>
            </TabContainer>
          }

          {tab === 1 &&
            <TabContainer>
              <CardContent>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="newPassword"
                    label={t[lang].newPassword}
                    value={newPassword}
                    type="password"
                    onChange={this.handleChangeNewPassword}
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="repeatPassword"
                    label={t[lang].repeatPassword}
                    value={repeatPassword}
                    type="password"
                    onChange={this.handleChangeRepeatPassword}
                  />
                </FormControl>
              </CardContent>
              <Divider />
              <CardActions className={classes.cardActions}>
                <Button color="primary" onClick={this.handleSavePassword}>
                  {t[lang].changePassword}
                </Button>
              </CardActions>
            </TabContainer>
          }
        </Card>

        {/*<Button
          variant="fab"
          color='secondary'
          onClick={this.handleSaveData}
          className={classes.saveButton}
        >
          <SaveIcon />
        </Button>*/}

        <Snackbar
          open={this.state.snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          variant='success'
          message={<span id="message-id">{snackMessage}</span>}
        />
      </Fragment>
    )
  }
}

UserDetailsCard.propTypes = {
  userId: PropTypes.string.isRequired,
}

function mapStateToProps ({ users }) {
  return {
    users
  }
}

export default connect(mapStateToProps)(withStyles(styles)(UserDetailsCard))


// WEBPACK FOOTER //
// ./src/components/Users/UserDetailsCard.js